import { useState } from 'react'
import { ServerCommandError } from '@/infrastructure/supabase/client'
import { useOnline } from '@/shared/hooks/useOnline'
import { useOperator } from '../../application/OperatorServices'
import { serverMessage } from '../../domain/fieldText'

/**
 * « Disponible pour aider » : déclaré par l'opérateur sans mission ouverte (sa sortie peut être fermée). L'état
 * affiché est celui que le serveur a enregistré; l'opérateur reste connecté.
 */
export function HelpAvailability() {
  const { repository, presence, setPresenceAvailable } = useOperator()
  const online = useOnline()
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const available = presence.availableForHelp

  async function toggle() {
    setSaving(true)
    setError(null)
    try {
      const result = await repository.setHelpAvailability(!available)
      setPresenceAvailable(result.availableForHelp)
    } catch (failure) {
      setError(
        failure instanceof ServerCommandError
          ? serverMessage(failure.code)
          : 'Le serveur n’a pas répondu : votre disponibilité n’a pas changé.',
      )
    } finally {
      setSaving(false)
    }
  }

  return (
    <section className="op-availability" aria-label="Disponibilité">
      <div className="op-settings__row">
        <span>
          <strong>Disponible pour aider</strong>
          <small>
            {available
              ? 'Le Centre des opérations vous voit disponible pour un renfort.'
              : 'Signalez au bureau que vous pouvez prendre des résidences d’une autre route.'}
          </small>
        </span>
        <button
          type="button"
          role="switch"
          aria-checked={available}
          aria-label="Disponible pour aider"
          className="op-switch"
          disabled={saving || !online}
          onClick={() => void toggle()}
        >
          {available ? 'Oui' : 'Non'}
        </button>
      </div>
      {!online ? <p className="op-muted">Hors connexion : disponibilité non modifiable.</p> : null}
      {error ? (
        <p className="op-error" role="alert">
          {error}
        </p>
      ) : null}
    </section>
  )
}
